import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { CookieService } from 'ngx-cookie-service';

import {
    TokenService,
    AuthService,
    PageProgressService,
    NotificationService,
    UserService,
    ApiService,
    PushNotificationService,
    UploadService,
    DomainService,
    StatisticsService,
    ReferralService,
    SettingsService,
    FinanceService,
    GeoService,
    PushNotifSectionService,
    LegalDomainService,

} from './services';



@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        RouterModule
    ]
})
export class CoreModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: CoreModule,
            providers: [
                TokenService,
                CookieService,
                PageProgressService,
                NotificationService,
                UserService,
                ApiService,
                AuthService,
                PushNotificationService,
                UploadService,
                DomainService,
                StatisticsService,
                ReferralService,
                SettingsService,
                FinanceService,
                GeoService,
                PushNotifSectionService,
                LegalDomainService
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts